import { render, staticRenderFns } from "./Periodicos.vue?vue&type=template&id=6902d744&scoped=true"
import script from "./Periodicos.vue?vue&type=script&lang=js"
export * from "./Periodicos.vue?vue&type=script&lang=js"
import style0 from "./Periodicos.vue?vue&type=style&index=0&id=6902d744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6902d744",
  null
  
)

export default component.exports